function Arguments(r){return Array.prototype.slice.call(r)}module.exports=Arguments;